import _ from 'lodash';
import types from 'frontend/state/actionTypes';

export default (state = [], action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.SUBMIT_SIM_SUCCESS: {
      // only save if user is logged in
      if (payload && !payload.isLoggedIn) {
        return state;
      }
      return [
        ...state,
        payload.data,
      ];
    }
    case types.REMOVE_JOB:
    case types.CANCEL_SIM: {
      const simId = payload;
      const remain = _.reject(state, { simId });
      return remain;
    }
    case types.FETCH_SIMS_SUCCESS:
      return payload;
    default:
      return state;
  }
};

export const selectors = {
  jobs: state => state.simbot.jobs,
};
